import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {TextUtils} from '../../utils/text_utils';
import {ColorUtils} from '../../utils';

// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const CircleText = ({children, searchString, value, color, noCircleText}) => {
	return (
		<Container>
			<Circle color={color}>{!noCircleText && TextUtils.getInitials(children)}</Circle>
			<Text title={children}>{children}</Text>
		</Container>
	);
};

export const Container = Styled.div`
	background-color: transparent;
	display: flex;
	flex-direction: row;
	padding: 5px 0;
	align-items: center;
	max-width: 100%;
`;

export const Circle = Styled.div`
	height: 30px;
	min-width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	border-radius: 50%;
	color: ${props => ColorUtils.getInvertedTextColor(props.color)};
	background-color: ${props => props.color};
	margin-right: 5px;
	text-transform: uppercase;
`;

export const Text = Styled.p`
	padding: 0;
	margin: 0;
	flex-grow: 1;
	font-size: 13px;
	width: 100%;
	color: ${props => props.theme.colors.textLightGray};
	white-space: nowrap;
  	overflow: hidden;
  	text-overflow: ellipsis;
`;

CircleText.propTypes = {
	children: PropTypes.any,
	searchString: PropTypes.string,
	value: PropTypes.any,
	color: PropTypes.string,
	noCircleText: PropTypes.bool,
};

CircleText.defaultProps = {
	color: '#470c93',
};
